import React, { useState, useEffect } from 'react';
import GoldCalculator from './components/GoldCalculator';
import './App.css';

const APP_PASSWORD = process.env.REACT_APP_PASSWORD || '2166';
const AUTH_TIMEOUT_MINUTES = parseInt(process.env.REACT_APP_AUTH_TIMEOUT_MINUTES || '10', 10);
const AUTH_KEY = 'tich-vang-auth';

function App() {
  const [authenticated, setAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    const authTimestamp = sessionStorage.getItem(AUTH_KEY);
    if (authTimestamp) {
      const elapsed = Date.now() - parseInt(authTimestamp, 10);
      if (elapsed < AUTH_TIMEOUT_MINUTES * 60 * 1000) {
        setAuthenticated(true);
      } else {
        sessionStorage.removeItem(AUTH_KEY);
      }
    }
  }, []);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === APP_PASSWORD) {
      setAuthenticated(true);
      sessionStorage.setItem(AUTH_KEY, Date.now().toString());
    } else {
      setError(true);
      setPassword('');
    }
  };

  if (!authenticated) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-4">
        <form onSubmit={handleSubmit} className="w-full max-w-xs text-center">
          <div className="text-4xl mb-2">🔒</div>
          <h1 className="text-xl font-bold text-yellow-600 mb-6">Tích Vàng</h1>
          <input
            type="password"
            inputMode="numeric"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(false); }}
            placeholder="Nhập mật khẩu"
            className={`w-full px-4 py-3 border rounded-lg text-center text-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 ${error ? 'border-red-400' : 'border-gray-300'}`}
            autoFocus
          />
          {error && <p className="text-red-500 text-sm mt-2">Sai mật khẩu</p>}
          <button
            type="submit"
            className="w-full mt-4 bg-yellow-500 text-white py-3 rounded-lg font-medium hover:bg-yellow-600 transition-colors"
          >
            Mở khóa
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="App">
      <GoldCalculator />
    </div>
  );
}

export default App;
